import environments from './environments';
import mode from './mode';
import appConfig from '../../../config/app.json';

const localhostCanChatRefresh = appConfig.appConfig?.localhost?.canChatRefresh ?? true;
const globalCanChatRefresh = appConfig.globalConfig?.canChatRefresh ?? true;

const canChatRefreshByMode = {
    [environments.PRODUCTION]: globalCanChatRefresh,
    [environments.DEVELOPMENT]: localhostCanChatRefresh,
    [environments.CUSTOM]: globalCanChatRefresh,
};

export const canChatRefresh = canChatRefreshByMode[mode];
